export const products = [
  {
    id: "raigeki-00",
    name: "雷撃カゴ 00",
    tagline: "超近距離",
    size: "SS / 1.5号オモリ",
    weight: "31g",
    color: "対象魚種 / グレ・チヌ・アジ・イサキ",
    spec: "",
    price: "2,500",
    accent: true,
    objectPosition: "center center",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/852857a90ff1089cc2186ec01c86735b.jpeg",
  },
  {
    id: "raigeki-01",
    name: "雷撃カゴ 01",
    tagline: "近距離",
    size: "S / 3号オモリ",
    weight: "59g",
    color: "対象魚種 / グレ・イサキ・マダイ",
    spec: "",
    price: "2,900",
    accent: true,
    objectPosition: "center center",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/7e3a0227b9a67f2d8bf46fa3db67a56c.jpeg",
  },
  {
    id: "raigeki-02",
    name: "雷撃カゴ 02",
    tagline: "中距離",
    size: "M / 6号オモリ",
    weight: "75g",
    color: "対象魚種 / グレ・イサキ・マダイ・青物",
    spec: "",
    price: "3,200",
    accent: true,
    objectPosition: "center center",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/9350d304fa2839e0df7c8ffe3b078c78.jpeg",
  },
  {
    id: "raigeki-03",
    name: "雷撃カゴ 03",
    tagline: "遠距離",
    size: "L / 8号オモリ",
    weight: "99g",
    color: "対象魚種 / 大型青物・マダイ",
    spec: "",
    price: "3,500",
    accent: true,
    objectPosition: "center center",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/0e569861cced3e3f9845666a20ef5393.jpeg",
  },
  {
    id: "short-tenbin",
    name: "ショート天秤",
    tagline: "短尺",
    size: "長さ / 約20cm",
    weight: "",
    color: "",
    spec: "針掛けリブ（突起） 太",
    price: "400",
    accent: false,
    objectPosition: "center center",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/5df6b785e25d020e60fe1aa027fa88ec.jpeg",
  },
  {
    id: "long-tenbin",
    name: "ロング天秤",
    tagline: "長尺",
    size: "長さ / 約35cm",
    weight: "",
    color: "",
    spec: "針掛けリブ（突起） 細",
    price: "850",
    accent: false,
    objectPosition: "center center",
    image:
      "https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/8a3c651874a8528a0858a46e78f1c7ad.jpeg",
  },
];